import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { dialogs, i18next } from '@yola/ws-sdk';
import { designSystem } from '@yola/ws-ui';
import dialogTypes from 'src/js/modules/dialogs/constants/dialog-types';
import segment from 'src/js/modules/analytics/segment';

const { EditorHeader } = designSystem;
const {
  constants: { triggerIds },
} = segment;

function PageButtonContainer() {
  const activeDialog = useSelector(dialogs.selectors.getDialog);
  const dispatch = useDispatch();
  const captions = {
    name: i18next.t('Pages'),
  };

  const showPageManager = useCallback(
    (event) => {
      if (activeDialog?.type === dialogTypes.PAGE_MANAGER) {
        return;
      }

      event.stopPropagation();
      dispatch(
        dialogs.actions.show(dialogTypes.PAGE_MANAGER, { triggerId: triggerIds.EDITOR_HEADER })
      );
    },
    [activeDialog, dispatch]
  );

  return <EditorHeader.PagesNavItem onMouseDown={showPageManager} label={captions.name} />;
}

export default PageButtonContainer;
